import styled from 'styled-components';

import { Color } from '../../../shared/constants/Colors';
import {
  FontSize,
  FontType,
  FontWeight,
} from '../../../shared/constants/Fonts';
import { Transition } from '../../../shared/constants/Styles';

export const Wrapper = styled.div`
  display: flex;
  align-items: center;
`;

export const GradientWrapper = styled.div`
  height: 0px;
  width: 0px;
  padding: 0px;
`;

export const HeartWrapper = styled.div`
  svg {
    font-size: 20px;
    color: ${Color.CARNATION_PINK};
    vertical-align: text-bottom;
    padding-right: 4px;

    ${({ isLiked }) =>
      isLiked &&
      `
      path {
        fill: url(#pink-gradient);
      }
    `}
  }
`;

export const Counter = styled.span`
  font-family: ${FontType.PRIMARY};
  font-size: ${FontSize.XS};
  font-weight: ${FontWeight.BLACK};
`;

export const LikeButton = styled.button`
  cursor: pointer;
  pointer-events: initial;
  transition: ${Transition.ALL_EASE};
  min-height: 45px;
  border-radius: 22.5px;
  background-clip: padding-box;
  outline: 0;
  display: inline-flex;
  align-items: center;
  font-weight: ${FontWeight.BLACK};
  font-size: ${FontSize.S};
  letter-spacing: 0;
  line-height: 19px;
  box-sizing: border-box;
  padding: 10px 0.5px;
  background-color: transparent;
  border: 2px solid ${Color.MYSTIC};

  svg {
    font-size: 20px;
    color: ${Color.CARNATION_PINK};
    vertical-align: text-bottom;
    padding: 0px 10px;

    ${({ isLiked }) =>
      isLiked &&
      `
      path {
        fill: url(#pink-gradient);
      }
    `}
  }

  &:hover {
    background-color: transparent;
    border: 2px solid ${Color.CLOUD_BURST};
  }

  &:focus-visible {
    background-color: ${Color.WHISPER};
    border: 2px solid ${Color.CLOUD_BURST};
  }
`;
